import React, { useEffect, useState } from "react";
import styles from "./ekyc.module.scss";

const DocumentVerification = ({ token }) => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
  }, []);
  return (
    <div className={styles.ekycWrapper}>
        <h5>Ekyc Document Verification</h5>
    </div>
  );
};

export default DocumentVerification;
